import { token } from '@terra/ui-styled-system';
export type GraphVisualizationColors = {
function: string;
file: string;
edge: string;
text: string;
background: string;
hoverShadow: string;
calls: string;
imports: string;
contains: string;
edgeStart: string;
edgeEnd: string;
};
export type GraphNodeType =
| 'CLIENT'
| 'ROUTING'
| 'CONFIGURATION'
| 'MIDDLEWARE'
| 'LOGIC'
| 'UTILITY'
| 'EVENT'
| 'DATABASE';
export const GRAPH_COLORS: GraphVisualizationColors = {
// Node colors - subtle, cool tones
function: token('colors.lilac.a3'),
file: token('colors.terra.a4'),
text: token('colors.gray.11'),
background: token('colors.gray.6'),
hoverShadow: token('colors.gray.4'),
// Edge colors - vibrant but not orange
edge: token('colors.lilac.8'),
calls: token('colors.lilac.9'),
imports: token('colors.terra.8'),
contains: token('colors.lilac.7'),
edgeStart: token('colors.lilac.9'),
edgeEnd: token('colors.terra.8'),
};
